import fs from "fs";
import path from "path";
import { Command } from "commander";
import { wrapper } from "./wrapper";
import { ReleaseOptions } from "./utils/types";
import { login, upgrade, init, build, release, rollback, history, disable, logout } from "./commands";

// Dynamically read version from package.json
const packageJsonPath = path.join(__dirname, "..", "package.json");
const { version } = JSON.parse(fs.readFileSync(packageJsonPath, "utf-8"));

const program = new Command();

program
  .name("superpush")
  .description("A SuperPe CodePush CLI tool")
  .version(version, "-v, --version", "Output the current version of SuperPe CodePush CLI");

program
  .command("login")
  .description("Login to SuperPush")
  .action(() => wrapper("login", () => login()));

program
  .command("upgrade")
  .description("Upgrade to the latest version of superpush cli")
  .argument("[version]", "Upgrade to a specify a version")
  .action((version: string) => wrapper("upgrade", () => upgrade(version)));

program
  .command("init")
  .description("Initialise the react application name")
  .action(() => wrapper("init", async () => init()));

program
  .command("build")
  .description("Build the bundle")
  .argument("[platform]", "Platform to build for (e.g., android, ios). By default, it builds for both platforms.")
  .action((platform: string) => wrapper("build", () => build(platform)));

program
  .command("release")
  .description("Release the bundle")
  .argument("<platform>", "Platform of the bundle")
  .argument("<release_version>", "Release version to push (e.g., x.x.x)")
  .option("-m, --message <message>", "Release message")
  .option("-f, --force", "Mark the release as mandatory")
  .option("-r, --rollout <rollout>", "Release rollout percentage", (value) => parseInt(value, 10))
  .option("-d, --delete", "Delete the bundle directory post release")
  .action((platform: string, release_version: string, options: ReleaseOptions) =>
    wrapper("release", () => release(platform, release_version, options))
  );

program
  .command("rollback")
  .description("Rollback to specific version")
  .argument("<platform>", "Platform to rollback (e.g., android, ios)")
  .argument("<release>", "Rollback to specified version (e.g., x.x.x)")
  .argument("<patch>", "Rollback to specified patch (e.g., vx)")
  .action((platform: string, release: string, patch: string) =>
    wrapper("rollback", () => rollback(platform, release, patch))
  );

program
  .command("history")
  .description("List the releases history")
  .argument("<platform>", "Releases by platform (e.g., android, ios)")
  .action((platform: string) => wrapper("history", () => history(platform)));

program
  .command("disable")
  .description("Disable the release for a specific platform")
  .argument("<platform>", "Platform to disable (e.g., android, ios)")
  .argument("<release>", "Disable specified version (e.g., x.x.x)")
  .argument("<patch>", "Disable specified patch (e.g., vx)")
  .action((platform: string, release: string, patch: string) =>
    wrapper("disable", () => disable(platform, release, patch))
  );

program
  .command("logout")
  .description("Logout from SuperPush")
  .action(() => wrapper("logout", () => logout()));

program.parse();
